import { createFilterStore } from './createFilterStore';

export const useTransactionFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  accountId: '',
  type: '',
  minAmount: '',
  maxAmount: '',
  // datePreset is UI-only (drives the dropdown); dateFrom/dateTo are what
  // actually go to the API. 'all' means no date bound.
  datePreset: 'all',
  dateFrom: '',
  dateTo: '',
  sortBy: 'transactionDate',
  sortOrder: 'desc' as const,
});
